<template>
    <v-card rounded="lg" elevation="0" class="grey-f8">
        <div class="pa-20 pa-md-30 pa-lg-40">
            <v-row class="row--x-small">
                <v-col cols="12" lg="6">
                    <recruitment-list-search-filter />
                </v-col>
                <v-col cols="12" lg="6">
                    <div class="input--search">
                        <v-text-field v-model="query.searchValue" placeholder="주소, 회사명, 공고명, 키워드로 검색해주세요" outlined hide-details @keydown.enter="search" />
                        <v-btn icon color="primary" class="transparent" @click="search"><i class="icon icon-search-black"></i></v-btn>
                    </div>
                    <!-- <v-row no-gutters class="mt-n16 ml-n16">
                        <v-col cols="12" lg="" class="pt-16 pl-16"> <v-text-field v-model="query.searchValue" prepend-inner-icon="mdi-magnify" placeholder="주소, 회사명, 공고명, 키워드로 검색해주세요" solo flat hide-details class="rounded-lg recruitment-list-search-field" @keydown.enter="search" /> </v-col>
                        <v-col cols="12" lg="auto" class="pt-16 pl-16"> <v-btn block color="blue lighten-2" @click="search">검색하기</v-btn> </v-col>
                    </v-row> -->
                </v-col>
            </v-row>
        </div>
    </v-card>
    <!-- <v-row no-gutters align="stretch">
        <v-col cols="12" md="5" lg="6">
            <recruitment-list-search-filter />
        </v-col>
        <v-col cols="12" md="7" lg="6" class="pt-16 pl-16">
            <v-card flat rounded="lg" color="blue lighten-5" class="d-flex flex-column fill-height">
                <v-card-title>검색하기</v-card-title>
                <v-card-text style="flex: 1 0 auto">
                    <v-row no-gutters class="mt-n16 ml-n16">
                        <v-col cols="12" lg="" class="pt-16 pl-16"> <v-text-field v-model="query.searchValue" prepend-inner-icon="mdi-magnify" placeholder="주소, 회사명, 공고명, 키워드로 검색해주세요" solo flat hide-details class="rounded-lg recruitment-list-search-field" @keydown.enter="search" /> </v-col>
                        <v-col cols="12" lg="auto" class="pt-16 pl-16"> <v-btn block color="blue lighten-2" @click="search">검색하기</v-btn> </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row> -->
</template>

<script>
import RecruitmentListSearchFilter from "./recruitment-list-search-filter.vue";

const initQuery = () => ({
    searchValue: null,
});

export default {
    components: { RecruitmentListSearchFilter },
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = { ...initQuery(), ...this.$route.query };
        },
        search() {
            let { ...query } = this.query;

            if (!query.searchValue) delete query.searchValue;
            delete query.page;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .recruitment-list-search-field .v-input__append-outer {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
    .v-select__selections{
        height: 20px;
        overflow: hidden;
    }
    .v-select__selection{
        margin: 0 4px 0 0;
    }
}
</style>